"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlacementDetails = void 0;
var adzerkHeaderBiddingUnitMap_1 = require("../config/adzerkHeaderBiddingUnitMap");
/**
 * return the configuration for this placement
 */
function getPlacementDetails(placement) {
    if (!Object.prototype.hasOwnProperty.call(adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap, placement)) {
        return undefined;
    }
    var details = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placement];
    return __assign({ placement_name: placement }, details);
}
exports.getPlacementDetails = getPlacementDetails;
